export default __webpack_public_path__ + "static/media/publisher3.e3509270.png";